import axios from "axios";
import { encode } from "base-64";

const API = {
  //PROVINCE
  getAllProvince: async ({ token }) => {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/province`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },
  //====================

  //CITY
  getAllCityByProvince: async ({ token, id }) => {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/city/${id}`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },
  //====================

  //OUTLET REQUEST
  getAllOutletRequest: async ({ token }) => {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/outletRequest/all`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  getAllOutletRequestByOutlet: async ({ token, id }) => {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/outletRequest/outlet/${id}`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  getAllOutletRequestDetailByOutletRequest: async ({
    token,
    id,
    trip = "",
    date = "",
  }) => {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/outletRequestDetail/outlet-request/${id}?trip=${trip}&date=${date}`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  getAllOutletRequestDetailByOutletRequestV2: async ({ token, id }) => {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/outletRequestDetail/outlet-request-v2/${id}`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  getRequestDetail: async ({
    token,
    id = "",
    search = "",
    startDate = "",
    endDate = "",
    currentPage,
    pageSize,
    outlet = "",
    warehouse = "",
    status = "",
    type = "",
  }) => {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/outletRequestDetail?requestId=${id}&search=${search}&startDate=${startDate}&endDate=${endDate}&currentPage=${currentPage}&pageSize=${pageSize}&outlet=${outlet}&warehouse=${warehouse}&status=${status}&type=${type}`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },
  //====================

  // SPK
  getAllSPK: async ({
    token,
    division_id = "",
    division_sub_id = "",
    outlet_id = "",
    product_id = "",
    status = "",
    date,
    category = "",
  }) => {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/spkProduction?division=${division_id}&divisionSub=${division_sub_id}&outlet=${outlet_id}&product=${product_id}&startDate=${date.dateFrom}&endDate=${date.dateTo}&status=${status}&category=${category}`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  getSPKById: async ({ token, id }) => {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/spkProduction/${id}`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  updateSPK: async ({ token, id, payload }) => {
    const { data } = await axios.patch(
      `${process.env.REACT_APP_BASE_URL}/spkProduction/${id}`,
      payload,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  createSPK: async ({ token, payload }) => {
    const { data } = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/spkProduction`,
      payload,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  prosesSPK: async ({ token, id }) => {
    const { data } = await axios.patch(
      `${process.env.REACT_APP_BASE_URL}/spkProduction/proses/${id}`,
      {},
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  deleteSPK: async ({ token, id }) => {
    const { data } = await axios.delete(
      `${process.env.REACT_APP_BASE_URL}/spkProduction/${id}`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  printSPKPengiriman: async ({ token, payload }) => {
    const { data } = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/print/spkDelivery`,
      payload,
      {
        headers: {
          access_token: `${token}`,
        },
        responseType: "arraybuffer",
      },
    );

    return data;
  },

  printSPKProduksi: async ({ token, payload }) => {
    const { data } = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/print/spkProduction`,
      payload,
      {
        headers: {
          access_token: `${token}`,
        },
        responseType: "arraybuffer",
      },
    );

    return data;
  },
  //====================

  productDropdown: async ({ token }) => {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/product-dropdown`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  warehouseByOutlet: async ({ token }) => {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/warehouse/getbyOutlet`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  warehouseByStock: async ({ token, productId }) => {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/dstock-warehouse-dropdown?productId=${productId}`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  stockConversion: async ({ token, unitId, productId, qty }) => {
    const { data } = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/dstock-conversion`,
      {
        unit_1: unitId, // unit before
        product_id: productId,
        qty,
      },
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  // PRODUKSI
  getAllProduction: async ({
    token,
    search,
    currentPage,
    projectPerPage,
    sort,
    sortType,
    productId,
    picId,
    status,
  }) => {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/production?search=${search}&currentPage=${currentPage}&pageSize=${projectPerPage}&sort=${sort}&sortType=${sortType}&productId=${productId}&picId=${picId}&status=${status}`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  createProduction: async ({ token, payload, pinData }) => {
    const { data } = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/production`,
      payload,
      {
        headers: {
          access_token: `${token}`,
          pin: pinData?.pin,
          employee_id: pinData?.employee_id,
          status_pin: pinData?.status_pin,
        },
      },
    );

    return data;
  },

  getAllBOMProduction: async ({
    token,
    search,
    currentPage,
    projectPerPage,
    sort,
    sortType,
    productId,
  }) => {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/production/bom?search=${search}&currentPage=${currentPage}&pageSize=${projectPerPage}&sort=${sort}&sortType=${sortType}&productId=${productId}`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  getProductionById: async ({ token, id }) => {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/production/${id}`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  getProductionStock: async ({ token, productId, unitId }) => {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/production-stock?productId=${productId}&unitId=${unitId}`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  createProductionDetail: async ({ token, payload }) => {
    const { data } = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/production-detail`,
      payload,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  moveProductionDetail: async ({ token, id, payload }) => {
    const { data } = await axios.patch(
      `${process.env.REACT_APP_BASE_URL}/production-detail-move/${id}`,
      payload,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  processProduction: async ({ token, id, pinData }) => {
    const { data } = await axios.patch(
      `${process.env.REACT_APP_BASE_URL}/production-process/${id}`,
      {},
      {
        headers: {
          access_token: `${token}`,
          pin: pinData?.pin,
          employee_id: pinData?.employee_id,
          status_pin: pinData?.status_pin,
        },
      },
    );

    return data;
  },

  finishProduction: async ({ token, id, payload }) => {
    const { data } = await axios.patch(
      `${process.env.REACT_APP_BASE_URL}/production-finish/${id}`,
      payload,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  deleteProduction: async ({ token, id }) => {
    const { data } = await axios.delete(
      `${process.env.REACT_APP_BASE_URL}/production/${id}`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },
  //====================

  // PENYIAPAN BAHAN
  getAllProductionBOM: async ({
    token,
    currentPage,
    projectPerPage,
    sort = "",
    sortType = "",
    productId = "",
    categoryId = "",
    type = "",
    typePage = "",
  }) => {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/production-bom?currentPage=${currentPage}&pageSize=${projectPerPage}&sort=${sort}&sortType=${sortType}&productId=${productId}&categoryId=${categoryId}&type=${type}&typePage=${typePage}`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  getAllProductionBOMKelapa: async ({
    token,
    currentPage,
    projectPerPage,
    sort,
    sortType,
    productId = "",
    categoryId = "",
    type = "",
    typePage = "",
  }) => {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/production-bom-kelapa?currentPage=${currentPage}&pageSize=${projectPerPage}&sort=${sort}&sortType=${sortType}&productId=${productId}&categoryId=${categoryId}&type=${type}&typePage=${typePage}`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  createSPKForPusat: async ({ token, payload }) => {
    const { data } = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/spkProduction-mainOutlet`,
      payload,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  //====================

  // BOM
  getAllBOM: async ({
    token,
    category,
    search,
    currentPage,
    projectPerPage,
    sort,
    sortType,
  }) => {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/bom?category=${category}&search=${search}&currentPage=${currentPage}&pageSize=${projectPerPage}&sort=${sort}&sortType=${sortType}`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  getBOMDropdown: async ({ token, product_id }) => {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/bom-dropdown?productId=${product_id}`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  getBOMById: async ({ token, id }) => {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/bom/${id}`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  createBOM: async ({ token, payload }) => {
    const { data } = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/bom`,
      payload,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  updateBOM: async ({ token, id, payload }) => {
    const { data } = await axios.patch(
      `${process.env.REACT_APP_BASE_URL}/bom/${id}`,
      payload,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  deleteBOM: async ({ token, id }) => {
    const { data } = await axios.delete(
      `${process.env.REACT_APP_BASE_URL}/bom/${id}`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  importBOM: async ({ token, payload }) => {
    const { data } = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/bom-import`,
      payload,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  uploadReceiptPO: async ({ token, id, payload }) => {
    if (!id) {
      throw new Error("ID Purchase Order tidak ada");
    }

    const rawUrl = `${process.env.REACT_APP_BASE_URL}/purchaseOrder/receipt-image/${id}`;
    const encodedId = encode(id);
    const encodedUrl = `${process.env.REACT_APP_BASE_URL}/purchaseOrder/receipt-image/${encodedId}`;

    try {
      const { data } = await axios.patch(rawUrl, payload, {
        headers: {
          access_token: token,
        },
      });

      return data;
    } catch (error) {
      const { data } = await axios.patch(encodedUrl, payload, {
        headers: {
          access_token: token,
        },
      });

      return data;
    }
  },

  //====================

  // PRODUCTION
  getMaterialSPKDetail: async ({
    token,
    search = "",
    productId = "",
    categoryId = "",
    currentPage = 1,
    projectPerPage = 10,
    sort = "",
    sortType = "",
  }) => {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/production-bom-detail?search=${search}&productId=${productId}&categoryId=${categoryId}&currentPage=${currentPage}&pageSize=${projectPerPage}&sort=${sort}&sortType=${sortType}`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },
  //====================

  // KOLAM
  getAllPool: async ({
    token,
    status,
    search,
    outletId,
    currentPage,
    projectPerPage,
    sort,
    sortType,
  }) => {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/pool?status=${status}&search=${search}&outletId=${outletId}&currentPage=${currentPage}&pageSize=${projectPerPage}&sort=${sort}&sortType=${sortType}`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  getPoolDropdown: async ({ token, outletId = "", status = "" }) => {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/pool-dropdown?outletId=${outletId}&status=${status}`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  getPoolById: async ({ token, id }) => {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/pool/${id}`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  createPool: async ({ token, payload }) => {
    const { data } = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/pool`,
      payload,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  updatePool: async ({ token, id, payload }) => {
    const { data } = await axios.patch(
      `${process.env.REACT_APP_BASE_URL}/pool/${id}`,
      payload,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  deletePool: async ({ token, id }) => {
    const { data } = await axios.delete(
      `${process.env.REACT_APP_BASE_URL}/pool/${id}`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  getPoolDetail: async ({
    token,
    id,
    status,
    finish,
    currentPage,
    projectPerPage,
    sort,
    sortType,
  }) => {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/pool-detail/${id}?status=${status}&finish=${finish}&currentPage=${currentPage}&pageSize=${projectPerPage}&sort=${sort}&sortType=${sortType}`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  finishPoolDetail: async ({ token, id }) => {
    const { data } = await axios.patch(
      `${process.env.REACT_APP_BASE_URL}/pool-detail/${id}`,
      {},
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  createActionPoolDetail: async ({ token, payload }) => {
    const { data } = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/pool-detail`,
      payload,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  createPoolIn: async ({ token, payload }) => {
    const { data } = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/good-receipt-pool`,
      payload,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  createPoolOut: async ({ token, payload }) => {
    const { data } = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/good-receipt-pool-out`,
      payload,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  getAllGoodReceiptPool: async ({ token, poolId = "" }) => {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/good-receipt-pool?poolId=${poolId}`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  //====================

  // GOOD RECEIPT PRODUCTION
  getAllGoodReceiptForProduction: async ({
    token,
    currentPage = 1,
    projectPerPage = 10,
    date = {
      dateFrom: "",
      dateTo: "",
    },
    supplier = "",
    type = "",
    search = "",
  }) => {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/good-receipt-production?currentPage=${currentPage}&pageSize=${projectPerPage}&dateFrom=${date.dateFrom}&dateTo=${date.dateTo}&supplierId=${supplier}&type=${type}&search=${search}`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  //====================

  // SOP
  getSOPDropdown: async ({ token }) => {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/SOP-dropdown`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  getSOPById: async ({ token, id }) => {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/SOP/${id}`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },
  //====================

  //LAPORAN
  getDetailPenjualan: async ({ token, order_code, menu }) => {
    const { data } = await axios.get(
      `${
        process.env.REACT_APP_BASE_URL
      }/orders/menuReports/${order_code}?menu=${encodeURIComponent(menu)}`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  getDetailPenjualanReservasi: async ({ token, reservationNo }) => {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/packageOrder/${reservationNo}`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  getLaporanPembatalan: async ({
    token,
    currentPage,
    pageSize,
    field,
    sort,
    search,
    date,
    typeChoice,
    outletSelected,
  }) => {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/orders/cancellationReports?currentPage=${currentPage}&pageSize=${pageSize}&sort=${field}&sortType=${sort}&search=${search}&dateFrom=${date.dateFrom}&dateTo=${date.dateTo}&paymentType=${typeChoice.value}&outletSelected=${outletSelected.value}`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  exportLaporanPenjualan: async ({ token, payload }) => {
    const { data } = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/orders/export/report-sales`,
      payload,
      {
        responseType: "blob",
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  exportLaporanOperasional: async ({ token, payload }) => {
    const { data } = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/orders/export/report-operational`,
      payload,
      {
        responseType: "blob",
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  printLaporanPenjualan: async ({ token, payload }) => {
    const { data } = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/orders/print/report-sales`,
      payload,
      {
        headers: {
          access_token: `${token}`,
        },
        responseType: "arraybuffer",
      },
    );

    return data;
  },

  printLaporanOperasional: async ({ token, payload }) => {
    const { data } = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/orders/print/report-operational`,
      payload,
      {
        headers: {
          access_token: `${token}`,
        },
        responseType: "arraybuffer",
      },
    );

    return data;
  },
  //====================

  //REQUEST TIME
  getAllReceiveProduct: async ({ token }) => {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/receive-product`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  getReceiveProductById: async ({ token, id }) => {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/receive-product/${id}`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  createReceiveProduct: async ({ token, payload }) => {
    const { data } = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/receive-product`,
      payload,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  updateReceiveProduct: async ({ token, id, payload }) => {
    const { data } = await axios.patch(
      `${process.env.REACT_APP_BASE_URL}/receive-product/${id}`,
      payload,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  deleteReceiveProduct: async ({ token, id }) => {
    const { data } = await axios.delete(
      `${process.env.REACT_APP_BASE_URL}/receive-product/${id}`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },
  //====================

  //WEIGHT SCALE
  getAllWeightScale: async ({ token }) => {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/weight-scale`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  getWeightScaleById: async ({ token, id }) => {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/weight-scale/${id}`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  createWeightScale: async ({ token, payload }) => {
    const { data } = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/weight-scale`,
      payload,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  updateWeightScale: async ({ token, payload, id }) => {
    const { data } = await axios.patch(
      `${process.env.REACT_APP_BASE_URL}/weight-scale/${id}`,
      payload,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  updateConditionWeightScale: async ({ token, id }) => {
    const { data } = await axios.patch(
      `${process.env.REACT_APP_BASE_URL}/weight-scale/condition/${id}`,
      { id },
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  deleteWeightScale: async ({ token, id }) => {
    const { data } = await axios.delete(
      `${process.env.REACT_APP_BASE_URL}/weight-scale/${id}`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },
  //====================

  verifyPin: async ({ token, payload }) => {
    const { data } = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/users/verifypin`,
      payload,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  //OUTLET
  getAllOutlet: async ({ token }) => {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/outlet/all`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },
  //====================

  //DIVISI
  getDivisiByOutlet: async ({ token }) => {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/division/all`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  getDivisiById: async ({ token, id }) => {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/division/${id}`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  updateDivisi: async ({ token, id, payload }) => {
    const { data } = await axios.patch(
      `${process.env.REACT_APP_BASE_URL}/division/${id}`,
      payload,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },
  //====================

  //SUB DIVISI
  createSubdivisi: async ({ token, payload }) => {
    const { data } = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/division-sub`,
      payload,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  updateSubdivisi: async ({ token, id, payload }) => {
    const { data } = await axios.patch(
      `${process.env.REACT_APP_BASE_URL}/division-sub/${id}`,
      payload,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  deleteSubdivisi: async ({ token, id }) => {
    const { data } = await axios.delete(
      `${process.env.REACT_APP_BASE_URL}/division-sub/${id}`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  getSubdivisi: async ({
    token,
    outletId = "",
    divisionId = "",
    search = "",
    currentPage = 1,
    pageSize = 100,
    sort = "createdAt",
    sortType = "desc",
  }) => {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/division-sub?outletId=${outletId}&divisionId=${divisionId}&search=${search}&currentPage=${currentPage}&pageSize=${pageSize}&sort=${sort}&sortType=${sortType}`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  getSubdivisiDropdown: async ({ token, divisionId, outletId }) => {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/division-sub-dropdown?divisionId=${divisionId}&outletId=${outletId}`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },
  //====================

  // WAREHOUSE
  getAllWarehouseNoPagination: async ({
    token,
    temporary = "",
    is_pic = true,
  }) => {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/warehouse/all?temporary=${temporary}&pic=${is_pic}`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  getWarehouseByPIC: async ({ token }) => {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/warehouse/getbyNip`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  getWarehouseByConfigWarehouse: async ({ token, product }) => {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/warehouse_getByConfigWarehouse?product_id=${encode(product)}`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  checkConfigWarehouse: async ({ token, product }) => {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/warehouse/check-config?product_id=${product}`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  printBarcodeWarehouse: async ({ token, payload }) => {
    const { data } = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/warehouse/printPdf`,
      payload,
      {
        headers: {
          access_token: `${token}`,
        },
        responseType: "arraybuffer",
      },
    );

    return data;
  },
  //====================

  //MODUL
  getAllModulNonPaginated: async ({ token }) => {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/menu/all`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },
  //====================

  // PRODUCT
  getAllProduct: async ({
    token,
    category,
    supplier,
    warehouse,
    warehouseName,
    currentPage,
    projectPerPage,
    field,
    sort,
    search,
    isBarangPajak,
  }) => {
    const { data } = await axios.get(
      `${
        process.env.REACT_APP_BASE_URL
      }/product?category=${category}&supplierQ=${supplier}&warehouse=${warehouse}&warehouseName=${warehouseName}&currentPage=${currentPage}&pageSize=${projectPerPage}&sort=${field}&sortType=${sort}${
        search ? `&search=${search}` : ""
      }${isBarangPajak ? `&isBarangPajak=${isBarangPajak}` : ""}`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  getAllProductNonPaginated: async ({ token }) => {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/product/all`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  getStockInformation: async ({ token, outlet = "", warehouse = "" }) => {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/dstock-information?outletId=${outlet}&warehouseId=${warehouse}`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  getStockInformationList: async ({
    token,
    currentPage,
    projectPerPage,
    outletId = "",
    warehouseId = "",
    search = "",
    type = "",
  }) => {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/dstock-information-list?currentPage=${currentPage}&pageSize=${projectPerPage}&type=${type}&search=${search}&outletId=${outletId}&warehouseId=${warehouseId}`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  getParentProductOnly: async ({ token }) => {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/product/getBySupplier/0`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  getChildProduct: async ({ token, id }) => {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/product/getByParent/${id}`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  deleteProduct: async ({ token, id }) => {
    const { data } = await axios.delete(
      `${process.env.REACT_APP_BASE_URL}/product/${id}`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  importProduk: async ({ token, payload }) => {
    const { data } = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/productImport`,
      payload,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  exportProduk: async ({ token, payload }) => {
    const { data } = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/productExport`,
      payload,
      {
        responseType: "blob",
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  getWarehouseByProduct: async ({ token, product_id }) => {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/config-warehouse-product/dropdown/${product_id}`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  getProductByWarehouse: async ({ token, warehouse_id }) => {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/product/getByStockWarehouse/${warehouse_id}`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },
  //====================

  // SUPPLIER
  getAllSupplierPaginated: async ({
    token,
    currentPage,
    projectPerPage,
    field,
    sort,
    search,
  }) => {
    const { data } = await axios.get(
      `${
        process.env.REACT_APP_BASE_URL
      }/supplier?currentPage=${currentPage}&pageSize=${projectPerPage}&sort=${field}&sortType=${sort}${
        search ? `&search=${search}` : ""
      }`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  getAllSupplier: async ({ token }) => {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/supplier_getSelectOption`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  getSupplierAccount: async ({ token, id }) => {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/supplier/account/${id}`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  createAccountSupplier: async ({ token, id }) => {
    const { data } = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/supplier/account/${id}`,
      {},
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  createProductSupplier: async ({ token, payload }) => {
    const { data } = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/supplier/product`,
      payload,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  updateSupplier: async ({ token, payload, id }) => {
    const { data } = await axios.patch(
      `${process.env.REACT_APP_BASE_URL}/supplier/${id}`,
      payload,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  updateHarga: async ({ token, payload, id }) => {
    const { data } = await axios.patch(
      `${process.env.REACT_APP_BASE_URL}/supplier/price/${id}`,
      payload,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  deleteProductSupplier: async ({ token, id }) => {
    const { data } = await axios.delete(
      `${process.env.REACT_APP_BASE_URL}/supplier/product/${id}`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  deleteSupplier: async ({ token, id }) => {
    const { data } = await axios.delete(
      `${process.env.REACT_APP_BASE_URL}/supplier/${id}`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  notifEmptyProduct: async ({ token, payload }) => {
    const { data } = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/supplier/notif-empty-product`,
      payload,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  purchaseListChangeEmpty: async ({ token, payload }) => {
    const { data } = await axios.patch(
      `${process.env.REACT_APP_BASE_URL}/purchaseList-changeempty`,
      payload,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },
  //====================

  //ROLE
  getAllRole: async ({ token }) => {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/role/all`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },
  //====================

  //MENU
  menu: async ({ token }) => {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/waitressV3/allMenuCategory`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  menuAdmin: async ({ token }) => {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/waitressV3/allMenuCategoryAdmin`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  createMenuGuide: async ({ token, payload }) => {
    const { data } = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/menu-guide`,
      payload,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  updateMenuGuide: async ({ token, payload, id }) => {
    const { data } = await axios.patch(
      `${process.env.REACT_APP_BASE_URL}/menu-guide/${id}`,
      payload,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  deleteMenuGuide: async ({ token, id }) => {
    const { data } = await axios.delete(
      `${process.env.REACT_APP_BASE_URL}/menu-guide/${id}`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  menuGuide: async ({ token }) => {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/menu-guide`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  menuGuideByPax: async ({ token, pax, guide, lead }) => {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/menu-guide-pax?pax=${pax}&guide=${guide}&lead=${lead}`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },
  //====================

  //MASTER DATA
  getMasterDataByType: async ({ token, type }) => {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/masterData/type/${type}`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  createMasterData: async ({ token, payload }) => {
    const { data } = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/masterData`,
      payload,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  updateMasterData: async ({ token, payload, masterDataId }) => {
    const { data } = await axios.patch(
      `${process.env.REACT_APP_BASE_URL}/masterData/${masterDataId}`,
      payload,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  deleteMasterData: async ({ token, masterDataId }) => {
    const { data } = await axios.delete(
      `${process.env.REACT_APP_BASE_URL}/masterData/${masterDataId}`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },
  //====================

  //REPORT
  detailKredit: async ({ token, type }) => {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/report/kredit?payment_type=${type}`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },
  rekapPenjualan: async ({
    token,
    start,
    end,
    search,
    outlet,
    sort,
    sortType,
  }) => {
    const { data } = await axios.get(
      `${
        process.env.REACT_APP_BASE_URL
      }/report/rekap-penjualan?search=${encodeURIComponent(
        search,
      )}&outlet=${outlet}&startDate=${start}&endDate=${end}&sort=${sort}&sortType=${sortType}`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },
  exportExcelRekapPenjualan: async ({
    token,
    start,
    end,
    currentPage,
    pageSize,
    search,
    outlet,
    sort,
    sortType,
  }) => {
    const { data } = await axios.get(
      `${
        process.env.REACT_APP_BASE_URL
      }/report/export-rekap-penjualan?search=${encodeURIComponent(
        search,
      )}&outlet=${outlet}&startDate=${start}&endDate=${end}&currentPage=${currentPage}&pageSize=${pageSize}&sort=${sort}&sortType=${sortType}`,
      {
        headers: {
          access_token: `${token}`,
        },
        responseType: "arraybuffer",
      },
    );

    return data;
  },
  rekapFastFood: async ({
    token,
    start,
    end,
    currentPage,
    pageSize,
    search,
    outlet,
  }) => {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/report/rekap-fastfood?search=${search}&outlet=${outlet}&startDate=${start}&endDate=${end}&currentPage=${currentPage}&pageSize=${pageSize}`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },
  reportMejaAktif: async ({
    token,
    room_code = "",
    table_code = "",
    order_code = "",
    outlet_id = "",
    sort = "",
    sortType = "",
    currentPage,
    projectPerPage,
  }) => {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/report/meja-aktif?currentPage=${currentPage}&pageSize=${projectPerPage}&room_code=${room_code}&order_code=${order_code}&outlet_id=${outlet_id}&sort=${sort}&sortType=${sortType}`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },
  reportPerubahanharga: async ({
    token,
    search = "",
    searchMenu = "",
    outlet_id = "",
    start = "",
    end = "",
    sort = "",
    sortType = "",
    currentPage,
    pageSize,
  }) => {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/report/perubahan-harga?currentPage=${currentPage}&pageSize=${pageSize}&outlet_id=${outlet_id}&sort=${sort}&sortType=${sortType}&search=${search}&search_menu=${searchMenu}&startDate=${start}&endDate=${end}`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },
  //====================

  //EMPLOYEE
  getSupervisor: async ({ token }) => {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/employeeBySupervisor`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  getByRole: async ({ token, role = "" }) => {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/employeeDropdown?role=${role}`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  getAllEmployeeOption: async ({ token, outletId = "" }) => {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/employee/all?outlet_id=${outletId ? encode(outletId) : ""}`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  //====================

  //AUDIT TRAIL
  getAllAuditTrail: async ({
    token,
    currentPage,
    projectPerPage,
    field,
    sort,
    date,
    search = "",
    filterAction,
  }) => {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/auditTrail?filter=${filterAction}&sort=${field}&sortType=${sort}&date=${date}&search=${search}&currentPage=${currentPage}&pageSize=${projectPerPage}`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  getDetailAuditTrail: async ({ token, id }) => {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/auditTrail/${id}`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },
  //====================

  //NOTIFICATION
  assignNotification: async ({ token, payload }) => {
    const { data } = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/assign_notification`,
      payload,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  updateAssignNotification: async ({ token, payload, id }) => {
    const { data } = await axios.patch(
      `${process.env.REACT_APP_BASE_URL}/assign_notification/${id}`,
      payload,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  deleteAssignNotification: async ({ token, id }) => {
    const { data } = await axios.delete(
      `${process.env.REACT_APP_BASE_URL}/assign_notification/${id}`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  getAllAssignNotification: async ({ token, notif_type = "" }) => {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/assign_notification?notif_type=${notif_type}`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  getAssignNotificationById: async ({ token, id }) => {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/assign_notification/${id}`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  getAllNotifType: async ({ token }) => {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/notification-type`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },
  //====================

  //TEMPORARY ACCESS
  createTemporaryAccess: async ({ token, payload }) => {
    const { data } = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/temporary-access`,
      payload,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  getAllTemporaryAccess: async ({ token }) => {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/temporary-access`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  deactivateAccessCode: async ({ token, tempAccessCodeId }) => {
    const { data } = await axios.patch(
      `${process.env.REACT_APP_BASE_URL}/deactivate/temporary-access/${tempAccessCodeId}`,
      {},
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },
  //====================

  //LIST PRODUCTION
  getListProduction: async ({ token, division, outlet, search }) => {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/outletListProduction?division=${division}&outlet=${outlet}&search=${search}`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  getListProductionByProduct: async ({ token, id }) => {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/outletListProduction/by-product/${id}`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  createListProduction: async ({ token, payload }) => {
    const { data } = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/outletListProduction`,
      payload,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  updateListProduction: async ({ token, id, payload }) => {
    const { data } = await axios.patch(
      `${process.env.REACT_APP_BASE_URL}/outletListProduction/${id}`,
      payload,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  deleteListProduction: async ({ token, id }) => {
    const { data } = await axios.delete(
      `${process.env.REACT_APP_BASE_URL}/outletListProduction/${id}`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },
  //====================

  //REQUEST TIME
  getRequestTime: async ({ token }) => {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/divisionRequestTime`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  getRequestTimeById: async ({ token, id }) => {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/divisionRequestTime/${id}`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  createRequestTime: async ({ token, payload }) => {
    const { data } = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/divisionRequestTime`,
      payload,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  updateRequestTime: async ({ token, id, payload }) => {
    const { data } = await axios.patch(
      `${process.env.REACT_APP_BASE_URL}/divisionRequestTime/${id}`,
      payload,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  deleteRequestTime: async ({ token, id }) => {
    const { data } = await axios.delete(
      `${process.env.REACT_APP_BASE_URL}/divisionRequestTime/${id}`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },
  //====================

  //STOK
  getAllStok: async ({
    token,
    currentPage,
    projectPerPage,
    search,
    warehouseId,
    outlet,
  }) => {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/dstock?currentPage=${currentPage}&pageSize=${projectPerPage}&search=${search}&outlet=${outlet}&warehouseId=${warehouseId}`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  getStockById: async ({ token, id }) => {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/dstock/${id}`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  getStockLog: async ({
    token,
    currentPage,
    projectPerPage,
    productId,
    warehouseId,
    startDate,
    endDate,
  }) => {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/dstock-log?currentPage=${currentPage}&pageSize=${projectPerPage}&productId=${productId}&warehouseId=${warehouseId}&startDate=${startDate}&endDate=${endDate}`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  inisiasiStok: async ({ token, payload }) => {
    const { data } = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/dstock`,
      payload,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  getStokDetailQty: async ({ token, product_id, warehouse_id }) => {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/dstock-detail-qty-temporary?product_id=${product_id}&warehouse_id=${warehouse_id}`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  getStockDetail: async ({ token, warehouseId, productId, qty }) => {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/dstock-detail-qty?warehouseId=${warehouseId}&productId=${productId}&qty=${qty}`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  getStockDetailWithDate: async ({ token, warehouseId, productId, qty }) => {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/dstock-detail-qty-date?warehouseId=${warehouseId}&productId=${productId}&qty=${qty}`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  getStockAdjustment: async ({ token, productId, warehouseId }) => {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/dstock-adjustment?productId=${productId}&warehouseId=${warehouseId}`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  stockAdjustment: async ({ token, payload, pinData }) => {
    const { data } = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/dstock-adjustment`,
      payload,
      {
        headers: {
          access_token: `${token}`,
          pin: pinData?.pin,
          employee_id: pinData?.employee_id,
          status_pin: pinData?.status_pin,
        },
      },
    );

    return data;
  },

  //====================

  //PROBLEM REPORT
  createProblemReport: async ({ token, payload }) => {
    const { data } = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/problem-report-bantuan`,
      payload,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  getAllProblemReport: async ({
    token,
    currentPage,
    projectPerPage,
    fetch,
    search,
    status,
    problemDate,
  }) => {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/problem-report-bantuan?currentPage=${currentPage}&pageSize=${projectPerPage}&fetch=${fetch}&search=${search}&status=${status}&startDate=${problemDate.dateFrom}&endDate=${problemDate.dateTo}`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  processProblemReport: async ({ token, id }) => {
    const { data } = await axios.patch(
      `${process.env.REACT_APP_BASE_URL}/problem-report-bantuan-process/${id}`,
      {},
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  closeProblemReport: async ({ token, id }) => {
    const { data } = await axios.patch(
      `${process.env.REACT_APP_BASE_URL}/problem-report-bantuan-close/${id}`,
      {},
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },
  //====================

  //RACK
  getRackOption: async ({ token, product_id = "" }) => {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/rack-dropdown?product=${product_id}`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  getRackOptionByStock: async ({ token, dstock_id = "" }) => {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/rack-dropdown-by-stock?dstock_id=${dstock_id}`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },
  //====================

  //WADAH
  getContainerOption: async ({ token }) => {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/wadah`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  getBorrowedContainer: async ({ token }) => {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/delivery-order-container-borrowed`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  returnContainer: async ({ token, payload }) => {
    const { data } = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/delivery-order-container`,
      payload,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },
  //====================

  // ASSET
  getAssetOption: async ({ token }) => {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/assetOption`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  getAssetOptionByWarehouse: async ({ token, warehouse_id }) => {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/assetOption-warehouse/${warehouse_id}`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },
  //====================

  //MUTATION REQUEST
  getAllMutationRequest: async ({
    token,
    currentPage,
    pageSize,
    sort = "",
    sortType = "",
    search = "",
    requestDateStart = "",
    requestDateEnd = "",
    outletId = "",
  }) => {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/mutationRequest?currentPage=${currentPage}&pageSize=${pageSize}&search=${search}&sort=${sort}&sortType=${sortType}&requestDateStart=${requestDateStart}&requestDateEnd=${requestDateEnd}&outlet=${outletId}`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  getMutationRequestById: async ({ token, id }) => {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/mutationRequest/${id}`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  getMutationRequestDetailById: async ({ token, id }) => {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/mutationRequest-detail/${id}`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  createMutationRequest: async ({ token, payload }) => {
    const { data } = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/mutationRequest`,
      payload,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  updateMutationRequest: async ({ token, payload, id }) => {
    const { data } = await axios.patch(
      `${process.env.REACT_APP_BASE_URL}/mutationRequest/${id}`,
      payload,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  postingMutationRequest: async ({ token, id }) => {
    const { data } = await axios.patch(
      `${process.env.REACT_APP_BASE_URL}/mutationRequest-posting/${id}`,
      {},
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  deleteMutationRequest: async ({ token, id, pinData }) => {
    const { data } = await axios.delete(
      `${process.env.REACT_APP_BASE_URL}/mutationRequest/${id}`,
      {
        headers: {
          access_token: `${token}`,
          employee_id: pinData?.employee_id,
          pin: pinData?.pin,
          status_pin: pinData?.status_pin,
        },
      },
    );

    return data;
  },

  processMutationRequest: async ({ token, id, payload }) => {
    const { data } = await axios.patch(
      `${process.env.REACT_APP_BASE_URL}/mutationRequest-process/${id}`,
      payload,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  deliveryMutationRequest: async ({ token, id, pinData }) => {
    const { data } = await axios.patch(
      `${process.env.REACT_APP_BASE_URL}/mutationRequest-delivery/${id}`,
      {},
      {
        headers: {
          access_token: `${token}`,
          employee_id: pinData?.employee_id,
          pin: pinData?.pin,
          status_pin: pinData?.status_pin,
        },
      },
    );

    return data;
  },

  receiveMutationRequest: async ({ token, payload, id }) => {
    const { data } = await axios.patch(
      `${process.env.REACT_APP_BASE_URL}/mutationRequest-receive/${id}`,
      payload,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  rejectMutationRequest: async ({ token, id, pinData }) => {
    const { data } = await axios.patch(
      `${process.env.REACT_APP_BASE_URL}/mutationRequest-reject/${id}`,
      {},
      {
        headers: {
          access_token: `${token}`,
          employee_id: pinData?.employee_id,
          pin: pinData?.pin,
          status_pin: pinData?.status_pin,
        },
      },
    );

    return data;
  },
  //====================

  //DELIVERY ORDER
  getAllDeliveryOrder: async ({
    token,
    currentPage,
    pageSize,
    sort = "",
    sortType = "",
    outletId = "",
    search = "",
    startDate = "",
    endDate = "",
    pageType = "",
  }) => {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/delivery-order?currentPage=${currentPage}&pageSize=${pageSize}&search=${search}&sort=${sort}&sortType=${sortType}&outletId=${outletId}&startDate=${startDate}&endDate=${endDate}&pageType=${pageType}`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  createDeliveryOrder: async ({ token, payload }) => {
    const { data } = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/delivery-order`,
      payload,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  updateDeliveryOrder: async ({ token, payload, id }) => {
    const { data } = await axios.patch(
      `${process.env.REACT_APP_BASE_URL}/delivery-order/${id}`,
      payload,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  postingDeliveryOrder: async ({ token, id }) => {
    const { data } = await axios.patch(
      `${process.env.REACT_APP_BASE_URL}/delivery-order-posting/${id}`,
      {},
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  deleteDeliveryOrder: async ({ token, id }) => {
    const { data } = await axios.delete(
      `${process.env.REACT_APP_BASE_URL}/delivery-order/${id}`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  getDetailQtyBarangPajak: async ({ token, id }) => {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/delivery-order-qtybpajak/${id}`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  outletRequestDelivery: async ({ token, payload, id }) => {
    const { data } = await axios.patch(
      `${process.env.REACT_APP_BASE_URL}/delivery-order-deliver/${id}`,
      payload,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  outletRequestReceive: async ({ token, payload, id }) => {
    const { data } = await axios.patch(
      `${process.env.REACT_APP_BASE_URL}/delivery-order-receive/${id}`,
      payload,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  rejectDeliveryOrder: async ({ token, id }) => {
    const { data } = await axios.patch(
      `${process.env.REACT_APP_BASE_URL}/delivery-order-reject/${id}`,
      {},
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },
  //====================

  //INVOICE
  getAllInvoice: async ({
    token,
    search = "",
    outletId = "",
    type = "",
    paymentStatus = "",
    currentPage,
    pageSize,
    sort = "",
    sortType = "",
    date = "",
    startDate = "",
    endDate = "",
    status = "",
  }) => {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/invoice-outlet?currentPage=${currentPage}&pageSize=${pageSize}&search=${search}&sort=${sort}&sortType=${sortType}&date=${date}&startDate=${startDate}&endDate=${endDate}&outletId=${outletId}&type=${type}&paymentStatus=${paymentStatus}&status=${status}`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  getDetailInvoice: async ({ token, id }) => {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/invoice-outlet/${id}`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  exportInvoice: async ({ token, id }) => {
    const { data } = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/invoice-outlet-excel/${id}`,
      {},
      {
        headers: {
          access_token: `${token}`,
        },
        responseType: "arraybuffer",
      },
    );

    return data;
  },

  updateInvoicePrice: async ({ token, id, payload }) => {
    const { data } = await axios.patch(
      `${process.env.REACT_APP_BASE_URL}/invoice-outlet/${id}`,
      payload,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  postingInvoice: async ({ token, id }) => {
    const { data } = await axios.patch(
      `${process.env.REACT_APP_BASE_URL}/invoice-outlet-posting/${id}`,
      {},
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  deleteInvoice: async ({ token, id }) => {
    const { data } = await axios.delete(
      `${process.env.REACT_APP_BASE_URL}/invoice-outlet/${id}`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  rejectInvoice: async ({ token, id }) => {
    const { data } = await axios.patch(
      `${process.env.REACT_APP_BASE_URL}/invoice-outlet-reject/${id}`,
      {},
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },
  //====================

  //PAYMENT
  getAllPayment: async ({
    token,
    search = "",
    currentPage,
    pageSize,
    sort = "",
    sortType = "",
    date = "",
    startDate = "",
    endDate = "",
  }) => {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/payment-invoice-outlet?currentPage=${currentPage}&pageSize=${pageSize}&search=${search}&sort=${sort}&sortType=${sortType}&date=${date}&startDate=${startDate}&endDate=${endDate}`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  getPaymentById: async ({ token, id }) => {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/payment-invoice-outlet/${id}`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  createPayment: async ({ token, payload }) => {
    const { data } = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/payment-invoice-outlet`,
      payload,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  //====================

  // KONVERSI RESERVASI
  exportKonversiReservasi: async ({
    token,
    field,
    sort,
    searchMenuName = "",
    searchProductName = "",
    pax = "",
    package_name = "",
  }) => {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/exportDataKonversi?sort=${field}&sortType=${sort}&searchMenuName=${searchMenuName}&searchProductName=${searchProductName}&pax=${pax}&package=${package_name}`,
      {
        headers: {
          access_token: `${token}`,
        },
        responseType: "arraybuffer",
      },
    );

    return data;
  },

  deleteKonversiReservasi: async ({ token, id }) => {
    const { data } = await axios.delete(
      `${process.env.REACT_APP_BASE_URL}/konversiReservasiPaket/${id}`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  deleteBatchKonversiReservasi: async ({
    token,
    menu_name,
    product_name,
    package_name,
    min_pax,
    max_pax,
  }) => {
    const { data } = await axios.delete(
      `${process.env.REACT_APP_BASE_URL}/konversiReservasiPaket-batch?menu_name=${menu_name}&product_name=${product_name}&package_name=${package_name}&min_pax=${min_pax}&max_pax=${max_pax}`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },
  //====================

  // RESERVASI PAKET
  getAllReservationPackage: async ({
    token,
    search = "",
    currentPage,
    date = {
      dateFrom: "",
      dateTo: "",
    },
    pageSize,
    sort = "reservation_time",
    sortType = "desc",
    status = "",
    outlet = "",
  }) => {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/reservation-package?search=${search}&startDate=${date.dateFrom}&endDate=${date.dateTo}&currentPage=${currentPage}&pageSize=${pageSize}&outlet=${outlet}&status=${status}&sort=${sort}&sortType=${sortType}`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  updateDriverReservationPackage: async ({ token, id, payload }) => {
    const { data } = await axios.patch(
      `${process.env.REACT_APP_BASE_URL}/reservation-package/update-driver/${id}`,
      payload,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },
  //====================

  // PRODUCT SPECIFICATION
  getAllProductSpec: async ({ token }) => {
    const { data } = await axios
      .get(`${process.env.REACT_APP_BASE_URL}/product-spec`, {
        headers: {
          access_token: `${token}`,
        },
      })
      .then((res) => {
        if (res.data.data.length > 0) {
          res.data.data = res.data.data.map((item) => ({
            ...item,
            label: item.name,
            value: item.product_spec_id,
          }));
        }
        return res;
      });

    return data.data;
  },

  getProductSpecById: async ({ token, id }) => {
    const { data } = await axios
      .get(`${process.env.REACT_APP_BASE_URL}/product-spec/${id}`, {
        headers: {
          access_token: `${token}`,
        },
      })
      .then((res) => {
        if (res.data.data.length > 0) {
          res.data.data = res.data.data.map((item) => ({
            ...item,
            label: item.name,
            value: item.product_spec_id,
          }));
        }
        return res;
      });

    return data.data;
  },

  createProductSpec: async ({ token, payload }) => {
    const { data } = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/product-spec`,
      payload,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  updateProductSpec: async ({ token, id, payload }) => {
    const { data } = await axios.patch(
      `${process.env.REACT_APP_BASE_URL}/product-spec/${id}`,
      payload,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },

  deleteProductSpec: async ({ token, id }) => {
    const { data } = await axios.delete(
      `${process.env.REACT_APP_BASE_URL}/product-spec/${id}`,
      {
        headers: {
          access_token: `${token}`,
        },
      },
    );

    return data;
  },
  //====================
};

export default API;
